import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import PropTypes from 'prop-types'
const ButtonLink = styled(Link)`
  font-size: 0.875em;
  text-align: center;
  line-height: 1em;
  &:hover {
    text-decoration: none;
  }
`
const ButtonItem = styled(Button)`
  display: block;
  box-sizing: border-box;
  height: ${props => props.height};
  width: ${props => props.width};
  cursor: pointer;
  border: 1px solid #54ce9d;
  border-radius: 5px;
  background: #ffffff;
  color: #54ce9d !important;
  margin: ${props => props.margin};
  padding: 0;
  &:hover,
  &:active {
    background-color: white !important;
    border-color: #54ce9d !important;
  }
`

export default function DetailsButton(props) {
  const { path, title, height, width, margin, campaign, from } = props
  return (
    <ButtonLink to={{ pathname: path, state: { campaign, from } }}>
      <ButtonItem height={height} width={width} margin={margin}>
        {title}
      </ButtonItem>
    </ButtonLink>
  )
}

DetailsButton.propTypes = {
  path: PropTypes.any,
  title: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  campaign: PropTypes.object,
  from: PropTypes.string,
}
DetailsButton.defaultProps = {
  path: '',
  height: '2em',
  width: '7.25em',
  margin: 'auto',
  from: '/',
}
